import React from "react";
import AccountNavBar from "./components/AccountNavBar";
import AccountInformation from "./components/AccountInformation/AccountInformation";
import AppNavBarWithBackAction from "../../modules/AppNavBarWithBackAction";
import { useTranslation } from "react-i18next";

const Account = () => {
  const { t } = useTranslation();
  return (
    <div className="px-6 mt-10">
      <AppNavBarWithBackAction title={t("your_account")} />

      <AccountNavBar />

      <AccountInformation />
    </div>
  );
};

export default Account;
